export const ONBOARDING_STEPS = [
  'welcome',
  'alpaca_signup',
  'alpaca_kyc',
  'alpaca_api_keys',
  'connect_account',
] as const;

export type OnboardingStepKey = (typeof ONBOARDING_STEPS)[number];

export type OnboardingStatus = {
  currentStep: string;
  completedSteps: string[];
  isComplete: boolean;
  steps: string[];
  firstName?: string | null;
  lastName?: string | null;
};

export const STEP_LABELS: Record<OnboardingStepKey, string> = {
  welcome: 'Welcome & compliance',
  alpaca_signup: 'Create Alpaca account',
  alpaca_kyc: 'Complete Alpaca KYC',
  alpaca_api_keys: 'Generate API keys',
  connect_account: 'Connect NovaQuantis',
};

export const ALPACA_LINKS = {
  signup: 'https://app.alpaca.markets/signup',
  dashboard: 'https://app.alpaca.markets/dashboard/overview',
  registerGuide: 'https://alpaca.markets/learn/register-on-alpaca',
  kycGuide: 'https://alpaca.markets/learn/live-trading-account-non-us',
  apiKeysGuide: 'https://alpaca.markets/learn/connect-to-alpaca-api',
  authDocs: 'https://docs.alpaca.markets/docs/authentication',
};

export const PAPER_ENDPOINT = 'https://paper-api.alpaca.markets/v2';
export const LIVE_ENDPOINT = 'https://api.alpaca.markets/v2';

/** Backend terminal step when onboarding is finished */
export const TERMINAL_STEP = 'done';

export const isOnboardingStepKey = (key: string): key is OnboardingStepKey =>
  (ONBOARDING_STEPS as readonly string[]).includes(key);
